import React, { Fragment } from 'react';
import { Box, Button, Container, createStyles, Grid, Theme, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import { makeStyles } from "@material-ui/core/styles";

interface Props {}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    ErrorBackground: {
      backgroundImage: 'url("/pattern_error.svg")',
      backgroundPosition: 'left top',
      backgroundRepeat: 'no-repeat',

      [theme.breakpoints.up('md')]: {
        backgroundPosition: 'center top'
      }
    }
  }),
);

const NotFound: React.FunctionComponent<Props> = (props) => {
  const classes = useStyles();

  return (
    <Fragment>
      <Box pt={{xs: 4, md: 6}}
           pb={{xs: 6, md: 12}}
           className={classes.ErrorBackground}
           component='main'
      >
        <Container>
          <Grid container>
            <Grid item xs={12} md={6}>
              <Typography component="h1" variant="h1" gutterBottom>
                <FormattedMessage
                  id='ErrorNotFoundTitle'
                  description='Error Not Found Title'
                />
              </Typography>
              <Typography variant='body1'>
                <FormattedMessage
                  id='ErrorNotFoundDescription'
                  description='Error Not Found Description'
                />
              </Typography>
              <Box mt={5}>
                <Button component={Link} to="/">
                  <FormattedMessage
                    id='ErrorNotFoundButton'
                    description='Error Not Found Button'
                  />
                </Button>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </Fragment>
  );
}

export default NotFound;
